// Tech name → URL slug helper + shared clickable chip component.
import { Link } from "react-router-dom";

export const techSlug = (s) =>
  String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "unknown";

// Reusable clickable chip. Variants:
//   "dark"  - black background (used on Insight/Tutorial detail headers)
//   "soft"  - light grey pill (used on Job cards)
//   "outline" - subtle outline (used on small list cards)
export const TechChip = ({ name, variant = "dark", size = "sm", testid }) => {
  if (!name) return null;
  const slug = techSlug(name);
  const base = "inline-block transition-colors font-mono-dl uppercase tracking-wider whitespace-nowrap";
  const sizeCls = size === "xs" ? "text-[10px] px-1.5 py-0.5" : "text-[11px] px-2 py-0.5";
  const variants = {
    dark: "bg-[#111827] text-white hover:bg-[#00A878]",
    soft: "bg-[#F3F4F6] text-[#111827] border border-[#E5E7EB] hover:border-[#111827] hover:text-[#00A878]",
    outline: "bg-white text-[#111827] border border-[#E5E7EB] hover:border-[#111827] hover:text-[#00A878]",
  };
  return (
    <Link
      to={`/tech/${slug}`}
      data-testid={testid || `tech-chip-${slug}`}
      className={`${base} ${sizeCls} ${variants[variant] || variants.dark}`}
    >
      {name}
    </Link>
  );
};
